// Décodage des "encoded-words" MIME (RFC 2047) présents dans les en-têtes
// d'email, ex: "=?UTF-8?Q?L2K,_Eliii_=F0=9F=92=8B?=" -> "L2K, Eliii 💋".
// Utilisé pour l'affichage des sujets reçus, que le backend stocke bruts.

const ENCODED_WORD = /=\?([^?]+)\?([BbQq])\?([^?]*)\?=/g;

function decodeQ(text) {
  const out = [];
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (c === "_") {
      out.push(0x20); // '_' représente un espace en Q-encoding
    } else if (c === "=" && i + 2 < text.length) {
      const code = parseInt(text.substr(i + 1, 2), 16);
      if (!isNaN(code)) {
        out.push(code);
        i += 2;
      } else {
        out.push(c.charCodeAt(0));
      }
    } else {
      out.push(c.charCodeAt(0));
    }
  }
  return new Uint8Array(out);
}

function decodeB(text) {
  const bin = atob(text.replace(/\s+/g, ""));
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes;
}

// Libellé lisible d'un expéditeur : le nom (ex: "Snapchat") s'il existe,
// sinon l'adresse (décodée si elle contient des encoded-words MIME).
export function senderLabel(msg) {
  if (!msg) return "";
  if (msg.sender_name) return msg.sender_name;
  return decodeMimeWords(msg.sender || "");
}

export function decodeMimeWords(input) {
  if (!input || typeof input !== "string") return input || "";
  if (!input.includes("=?")) return input; // rien à décoder

  // Les encoded-words adjacents séparés uniquement par des espaces sont
  // recollés (l'espace est supprimé) — RFC 2047 §6.2.
  const collapsed = input.replace(
    /(=\?[^?]+\?[BbQq]\?[^?]*\?=)\s+(?==\?[^?]+\?[BbQq]\?[^?]*\?=)/g,
    "$1"
  );

  return collapsed.replace(ENCODED_WORD, (match, charset, enc, text) => {
    try {
      const bytes = enc.toUpperCase() === "B" ? decodeB(text) : decodeQ(text);
      const cs = (charset || "utf-8").toLowerCase();
      try {
        return new TextDecoder(cs).decode(bytes);
      } catch {
        return new TextDecoder("utf-8").decode(bytes);
      }
    } catch {
      return match; // en cas d'échec, on laisse le texte brut
    }
  });
}
